import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Intro from "../pages/intro/Intro";
import SecondRegisterStep from "../pages/sign-up/SecondRegisterStep";
import Shop from "../pages/shop/Shop";
import MainRoot from "../pages/main/MainRoot";
import Main from "../pages/main/Main";
import Influencer from "../pages/influencer/Influencer";
import Scheduling from "../pages/scheduling/Scheduling";
import FindDietitian from "../pages/findDietitian/FindDietitian";
import Product from "../pages/shop/Product";
import Box from "../pages/gepz-box/GepzoBox";
import Cart from "../pages/cart/Cart";
import Checkout from "../pages/checkout/Checkout";
import Payment from "../pages/payment/Payment";
import ConfirmEmail from "../pages/reset-password/ConfirmEmail";
import EnterCode from "../pages/reset-password/EnterCode";
import SetPassword from "../pages/reset-password/SetPassword";
import LogIn from "../pages/log-in/LogIn.jsx";
import Register from "../pages/register/Register";

function App() {
  const router = createBrowserRouter([
    {
      path: "",
      element: <Intro />,
    },
    {
      path: "everyone/",
      element: <MainRoot />,
      children: [
        {
          path: "",
          element: <Main />,
        },
        {
          path: "shop/",
          element: <Shop />,
        },
        {
          path: "shop/:productId",
          element: <Product />,
        },
        {
          path: "shop/cart",
          element: <Cart />,
        },
        {
          path: "shop/checkout",
          element: <Checkout />,
        },
        {
          path: "shop/payment",
          element: <Payment />,
        },
        {
          path: "influencers/",
          element: <FindDietitian />,
        },
        {
          path: "influencers/:influencerId",
          element: <Influencer />,
        },
        {
          path: "influencers/:influencerId/scheduling",
          element: <Scheduling />,
        },
        {
          path: "gepzo-box",
          element: <Box />,
        },
      ],
    },
    {
      path: "log-in",
      element: <LogIn />,
    },
    {
      path: "register/step-1",
      element: <Register />,
    },
    {
      path: "register/step-2",
      element: <SecondRegisterStep />,
    },
    {
      path: "reset-password/email-confirmation",
      element: <ConfirmEmail />,
    },
    {
      path: "reset-password/code",
      element: <EnterCode />,
    },
    {
      path: "reset-password/set-password",
      element: <SetPassword />,
    },
  ]);

  document.body.classList.add("bg-[#F3F3F3]");
  return <RouterProvider router={router}></RouterProvider>;
}

export default App;
